import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../../ui/breadcrumbs';

const AdminShell = ({ eyebrow, title, description, breadcrumbs, actions, children }) => {
  return (
    <div className='min-h-screen bg-background'>
      <div className='max-w-[1240px] mx-auto px-6 md:px-10 py-8'>
        {breadcrumbs && breadcrumbs.length > 0 ? (
          <Breadcrumb className='mb-4'>
            <BreadcrumbList>
              {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return (
                  <React.Fragment key={`${crumb.label}-${index}`}>
                    <BreadcrumbItem>
                      {isLast || !crumb.to ? (
                        <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink asChild>
                          <Link to={crumb.to}>{crumb.label}</Link>
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast ? <BreadcrumbSeparator /> : null}
                  </React.Fragment>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        ) : null}

        <div className='flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6'>
          <div>
            {eyebrow ? (
              <div className='flex items-center gap-2 mb-2'>
                <div className='w-6 h-px bg-primary' />
                <span className='font-mono text-[10px] tracking-[0.18em] uppercase text-primary'>{eyebrow}</span>
              </div>
            ) : null}
            {title ? <h1 className='font-display text-3xl text-foreground leading-tight'>{title}</h1> : null}
            {description
              ? typeof description === 'string'
                ? <p className='text-[15px] text-muted-foreground max-w-[680px] leading-relaxed mt-2'>{description}</p>
                : <div className='mt-2'>{description}</div>
              : null}
          </div>
          {actions ? <div className='flex items-center gap-2 flex-wrap'>{actions}</div> : null}
        </div>

        {children}
      </div>
    </div>
  );
};

export default AdminShell;
